module.exports = __webpack_public_path__ + "static/media/android-certification-course.c26c9c2c.png";